export const CURRENCY_FIELDS = [
  'Kosten Catering netto',
  'zzgl. 7 % MwSt.',
  'Zwischensumme  Catering',
  'Kosten Kurier netto',
  'zzgl. 19% MwSt.',
  'Zwischensumme Kurierkosten',
  'Material/ Wiederbeschaffung',
  'Service inkl. 19% MwSt.',
  'zwischemsumme',
  'zzgl 7% Mwst 2',
  'Gesamtsumme (Zwischensumme1+2)'
] as const;

export type CurrencyField = typeof CURRENCY_FIELDS[number];
